import { IMSObject, IMSId } from './ims-object';

/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190402 by Jan Brunner
 *     all rights reserved.
 */

export class ActivityType extends IMSObject {
  static fromDto(dto: ActivityTypeDTO, databag?: any) {
    const obj = new this(
      {
        imsId: dto.id,
        secondaryId: dto.secondaryid,
        objRef: 'ims/ActivityType'
      },
      dto.label,
      dto.name,
      dto.comment
    );

    if (databag) {
      obj.databag = databag;
    } else {
      obj.databag = dto;
    }
    return obj;
  }

  constructor(
    public readonly id: IMSId,
    label: string,
    public name: string,
    public comment: string,
  ) {
    super(id.imsId, id.secondaryId, label, 'ims/ActivityType');
  }
}

export interface ActivityTypeDTO {
  id: number;
  secondaryid: number;
  label: string;
  name: string;
  comment: string;
}
